import theme from 'shared/src/styles/theme'
const styles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    color: theme.palette.common.black
  }

  export default styles;